import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router } from '@angular/router';
import { AuthenticationService, UserService } from '@ca/core/services';

@Injectable({
    providedIn: 'root',
})
export class AdminGuard implements CanActivate, CanLoad {
    constructor(
        private userService: UserService,
        private authenticationService: AuthenticationService,
        private router: Router,
    ) {}

    canActivate(): boolean {
        return this.hasRightToAccessAdminPage();
    }

    canLoad(): boolean {
        return this.hasRightToAccessAdminPage();
    }

    private hasRightToAccessAdminPage(): boolean {
        const isAuthenticated = this.authenticationService.hasValidAccessToken();
        let isAdmin: boolean = false;

        if (this.userService.myInfo != null) {
            isAdmin = this.userService.myInfo.isAdmin;
        }

        if (isAuthenticated && !isAdmin) {
            this.router.navigate(['permission-denied']);
        }

        return isAuthenticated && isAdmin;
    }
}
